import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p04 } from "../../../layouts/ch6_p04/ch6_p04";

export class Chapter6Page4 extends AbstractStoryState implements ReturnType<typeof ch6_p04> {

    readonly bg = this.addChild(new SceneSprite());
    readonly hollyBody = this.addChild(new SceneSprite());
    readonly hollyArms = this.addChild(new SceneSprite());
    readonly rain = [this.addChild(SceneSprite.withPrefix("ch6_p04/")), this.addChild(SceneSprite.withPrefix("ch6_p04/"))];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p04/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p04/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch6_p04/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch6_p04/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p04.call(this);

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, () => {
            this.gotoNextState({ transition: "left" });
        });
    }
}